import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment"
import { map, share } from "rxjs/operators";
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { SystemService } from "./system.service";
@Injectable({ providedIn: 'root' })export class CompanyReportGeneratorService {

  queryPath;
  dataArySubs = new Subject();
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private systemService: SystemService, private http: HttpClient) {
    // this.setQueryPath()
  }

  // setQueryPath() {
  //     this.queryPath = this.afs.collection('company')
  //         .doc(this.config.getCompanyId())
  //         .collection('transactions').ref;
  // }

  // getData(data) {
  //     console.log(data)
  //     let ref = this.queryPath;

  //     ref = this.myFilter(ref, `projectId`, `==`, data.projectId);
  //     ref = this.myFilter(ref, `productId`, `==`, data.productId);
  //     ref = this.myFilter(ref, `systemId`, `==`, data.systemId);
  //     ref = this.myFilter(ref, `employeId`, `==`, data.employeeId);
  //     ref = this.myFilter(ref, `date`, `>=`, data.dateFrom);
  //     ref = this.myFilter(ref, `date`, `<=`, data.dateTo);

  //     ref.limit(500).get()
  //     .then(qs => {
  //         let arr = []
  //         qs.forEach(doc=>{
  //             arr.push(doc.data())
  //         })
  //         this.dataArySubs.next(arr)
  //     });

  // }

  getData(body) {
    body = JSON.stringify(body);
    body = JSON.parse(body)
    console.log("focus by all")

    // delete body['focusBy']
    // return this.http.post(environment.apiUrl + "/widgets/reportgenerator", JSON.stringify(body), this.httpOptions).pipe(map(res => {
    //   if (Array.isArray(res)) {
    //     return res.map((item) => { return { ...item, date: moment.unix(item.unix).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm'), groupId: item.user.groupId ? item.user.groupId : "Unknow" } });
    //   } else {
    //     return;
    //   }
    // }));
  }

  getDataByProduct(body) {

    body = JSON.stringify(body);
    body = JSON.parse(body)
    body.status = true; // to get only successfull transactions
    delete body['focusBy']
    console.log("focus by product")
    return this.http.post(environment.apiUrl + "/widgets/reportgeneratorbyprodcut", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {
        return res.map((item) => { return { ...item, date: moment.unix(item.unix).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm') } });
      } else {
        return null;
      }
    })).pipe(share());;
  }

  getAll(body) {
    body = JSON.stringify(body);
    body = JSON.parse(body)
    body.status = true; // to get only successfull transactions
    delete body['focusBy']
    console.log("focus by",body)
    return this.http.post(environment.apiUrl + "/widgets/reportgenerateall", JSON.stringify(body), this.httpOptions).pipe(map(res => {
      if (Array.isArray(res)) {

        // return res.map((item) => { return { ...item,project:item.project != null ? item.project.name: 'Not Assigned', freeText:item.freeText != null  ? item.freeText: '-'}});

        return res.map((item) => { return { ...item, discount:item.discount?item.discount : 0, subsidized:  (item.price * (item.discount / 100)).toFixed(2) , groupId: item.user ? item.user.groupId : "Unknow" ,userName: item.user ? item.user.name : "", date: moment.unix(item.unix).tz('Europe/Oslo').format('DD-MM-YYYY HH:mm') } }).sort((a, b) => b.unix - a.unix)

      } else {
        return null;
      }
    })).pipe(share());
  }

}